jQuery(function($){
  var sliderEl = document.querySelector('[data-ref="product-slider"]');
  var thumbsSliderEl = document.querySelector('[data-ref="product-thumbs-slider"]');
  var popinEl = document.querySelector('[data-ref="product-popin"]');
  var popinSliderEl = document.querySelector('[data-ref="product-popin-slider"]');
  var popinCloseEl = document.querySelector('[data-ref="product-popin-close"]');

  var swiperThumb = new Swiper(thumbsSliderEl, {
    slidesPerView: 4,
    loop: false,
    spaceBetween: 15,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 6
    }
  });
  var swiperPopin = new Swiper(popinSliderEl, {
    slidesPerView: 1,
    loop: false,
    spaceBetween: 8,
    navigation: {
      nextEl: '.product-slider-popin__next',
      prevEl: '.product-slider-popin__prev',
    },
    keyboard: true,
    lazy: {
      loadPrevNext: true
    }
  });
  var swiperMain = new Swiper(sliderEl, {
    slidesPerView: 1,
    loop: false,
    spaceBetween: 8,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true
    },
    thumbs: {
      swiper: swiperThumb
    },
    // breakpoints: {
    //   1024: {
    //     scrollbar: false,
    //     navigation: {
    //       nextEl: '.product-slider__next',
    //       prevEl: '.product-slider__prev',
    //     },
    //   }
    // },
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2
    }
  });
  swiperPopin.controller.control = swiperMain;
  swiperMain.controller.control = swiperPopin;

  var popinTrap = focusTrap.createFocusTrap(popinEl, {
    fallbackFocus: function() {
      return popinCloseEl;
    },
    onActivate: function() {
      App.disableScrolling();
      popinEl.style.display = 'block';
      swiperPopin.lazy.load();
      swiperPopin.update();
    },
    onDeactivate: () => {
      App.enableScrolling();
      popinEl.style.display = 'none';
    },
  });

  $('[data-ref="product-popin"]').on('click', function(e) {
    if (e.target.classList.contains('swiper-slide') || e.target.classList.contains('swiper') || e.target.classList.contains('product-slider-popin')) {
      popinTrap.deactivate();
    }
  });
  $('[data-ref="product-popin-close"]').on('click', function() {
    popinTrap.deactivate();
  });
  $('[data-ref="product-slide"]').on('click', function() {
    popinTrap.activate();
  });
  $('[data-ref="product-thumbs-slide"]').on('click', function() {
    popinTrap.activate();
  });
});
